<template lang="pug">
  div.image(:class="'image-'+this._uid")
    img(:src="this.payload.fields.file.url" :alt="this.payload.fields.title" :width="this.imageWidth" :height="this.imageHeight")
</template>

<script>

import Vue from 'vue'

// component instance
var imageBlock = Vue.component('image-block', {
  name: 'imageBlock',
  props: {
    payload: {
      default: () => { return {fields: {title: '', file: {fileName: '', url: '', details: {image: {width: 0, height: 0}}}}} },
      type: Object
    }
  },
  data: function () {
    return {}
  },
  watch: {
  },
  methods: {

  },
  computed: {
    imageWidth () {
      let w = this.payload.fields.file.details.image.width
      w = this.isRetina ? w / 2 : w

      return w
    },
    imageHeight () {
      let h = this.payload.fields.file.details.image.height
      h = this.isRetina ? h / 2 : h

      return h
    },
    isRetina () {
      return this.payload.fields.file.fileName.match('@2x') !== null || this.payload.fields.title.match('@2x') !== null
    }
  },
  created () {
  },
  mounted () {
  },
  beforeCreate () {
  },
  beforeUpdate () {
  },
  beforeDestroy () {
  }
})

// export component
export default imageBlock
</script>

<style scoped>
  .image, img{
    max-width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/imageBlock.vue